import { createSlice } from '@reduxjs/toolkit'

// Slice
const initialProject = {
    project: {},
    sectionData: [],
    optionData: [],
    variationData: [],
    projectVariation: [],
    sectionVariation: [],
    projectcard: {},
    progresscard: {},
    financialCard: {},
    overviewCards: {},
    sections: {},
    variations: {},
    options: {},
    projectTotal: {},
    revisedProjectTotal: {},
    labors: [],
    userNames: [],
    subcontractors: [],
    laborData: {},
    progressClaims: [],
    optionsList: [],
    resourceAllocations: []
};

const slice = createSlice({
    name: 'projectData',
    initialState: {
        ...initialProject,
    },
    reducers: {
        addProject: (state, action) => {
            state.project = {
                ...state.project,
                ...action.payload
            }
        },
        updateProject: (state, action) => {
            state.project = {
                ...state.project,
                ...action.payload
            }
        },
        addSectionData: (state, action) => {
            state.sectionData = action.payload;
        },
        addOptionData: (state, action) => {
            state.optionData = action.payload;
        },
        addVariationData: (state, action) => {
            state.variationData = action.payload;
        },
        addProjectVariation: (state, action) => {
            state.projectVariation = action.payload;
        },
        addSectionVariation: (state, action) => {
            state.sectionVariation = action.payload;
        },
        addProjectCard: (state, action) => {
            state.projectcard = action.payload;
        },
        addProgressCard: (state, action) => {
            state.progresscard = action.payload;
        },
        addFinancialCard: (state, action) => {
            state.financialCard = action.payload;
        },
        addOverviewCards: (state, action) => {
            state.overviewCards = action.payload;
        },
        addSections: (state, action) => {
            state.sections = action.payload;
        },
        addVariations: (state, action) => {
            state.variations = action.payload;
        },
        addOptions: (state, action) => {
            state.options = action.payload;
        },
        addProjectTotal: (state, action) => {
            state.projectTotal = action.payload;
        },
        addRevisedProjectTotal: (state, action) => {
            state.revisedProjectTotal = action.payload;
        },
        addLabor: (state, action) => {
            state.labors = action.payload
        },
        addUserNames: (state, action) => {
            state.userNames = action.payload
        },
        addSubcontractors: (state, action) => {
            state.subcontractors = action.payload
        },
        addLaborData: (state, action) => {
            state.laborData = action.payload;
        },
        addProgressClaims: (state, action) => {
            state.progressClaims = action.payload;
        },
        addOptionsList: (state, action) => {
            state.optionsList = action.payload;
        },
        addResourceAllocations: (state, action) => {
            state.resourceAllocations = action.payload;
        },
        updateSectionDetails: (state, action) => {
            const { stageId, name, description, attachment } = action.payload || {};
            const updateRecursive = (stages) => {
                return stages.map(stage => {
                    let updatedStage = { ...stage };
                    if (stage.id === stageId) {
                        if (name !== undefined) updatedStage.name = name;
                        if (description !== undefined) updatedStage.description = description;
                        if (attachment !== undefined) updatedStage.attachment = attachment;
                    }
                    if (stage.stages && stage.stages.length > 0) {
                        updatedStage.stages = updateRecursive(stage.stages);
                    }
                    return updatedStage;
                });
            };
            if (Array.isArray(state.sectionData)) {
                state.sectionData = updateRecursive(state.sectionData);
            }
            if (state.sections && state.sections[stageId]) {
                if (name !== undefined) state.sections[stageId].stageName = name;
                if (description !== undefined) state.sections[stageId].stageDescription = description;
            }
        },
        clearProject: (state) => {
            Object.assign(state, initialProject);
        }
    },
});

export default slice.reducer;

// Actions
const {
    addProject,
    updateProject,
    addSectionData,
    addOptionData,
    addVariationData,
    addProjectVariation,
    addSectionVariation,
    addProjectCard,
    addProgressCard,
    addFinancialCard,
    addOverviewCards,
    addSections,
    addVariations,
    addOptions,
    addProjectTotal,
    addRevisedProjectTotal,
    addLabor,
    addUserNames,
    addSubcontractors,
    addLaborData,
    addProgressClaims,
    addOptionsList,
    addResourceAllocations,
    updateSectionDetails,
    clearProject
} = slice.actions;

/**
 * Redux action to update section/stage name, description, and attachment in-place within sectionData and sections.
 *
 * @param {Object} data - Section details payload
 * @param {string} data.stageId - ID of stage to update
 * @param {string} [data.name] - New stage name
 * @param {string} [data.description] - New stage description
 * @param {Array} [data.attachment] - New stage attachments
 * @returns {Function} Redux thunk function
 */
export const updateSectionDetailsAction = (data) => async dispatch => {
    try {
        dispatch(updateSectionDetails(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addProjectAction = (data) => async dispatch => {
    try {
        dispatch(addProject({ ...data }));
    } catch (e) {
        return console.error(e);
    }
}

export const updateProjectAction = (data) => async dispatch => {
    try {
        dispatch(updateProject({ ...data }));
    } catch (e) {
        return console.error(e);
    }
}

export const addSectionDataAction = (data) => async dispatch => {
    try {
        dispatch(addSectionData(data));
    } catch (e) {
        return console.error(e);
    }
}
export const addOptionDataAction = (data) => async dispatch => {
    try {
        dispatch(addOptionData(data));
    } catch (e) {
        return console.error(e);
    }
}
export const addVariationDataAction = (data) => async dispatch => {
    try {
        dispatch(addVariationData(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addProjectVariationAction = (data) => async dispatch => {
    try {
        dispatch(addProjectVariation(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addSectionVariationAction = (data) => async dispatch => {
    try {
        dispatch(addSectionVariation(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addProjectCardAction = (data) => async dispatch => {
    try {
        dispatch(addProjectCard(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addProgressCardAction = (data) => async dispatch => {
    try {
        dispatch(addProgressCard(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addFinancialCardAction = (data) => async dispatch => {
    try {
        dispatch(addFinancialCard(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addOverviewCardsAction = (data) => async dispatch => {
    try {
        dispatch(addOverviewCards(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addSectionsAction = (data) => async dispatch => {
    try {
        dispatch(addSections(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addVariationsAction = (data) => async dispatch => {
    try {
        dispatch(addVariations(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addOptionsAction = (data) => async dispatch => {
    try {
        dispatch(addOptions(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addProjectTotalAction = (data) => async dispatch => {
    try {
        dispatch(addProjectTotal(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addRevisedProjectTotalAction = (data) => async dispatch => {
    try {
        dispatch(addRevisedProjectTotal(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addLevelAction = (data) => async dispatch => {
    try {
        dispatch(addLabor(data));
    } catch (e) {
        return console.error(e);
    }
}
export const addUserNamesAction = (data) => async dispatch => {
    try {
        dispatch(addUserNames(data));
    } catch (e) {
        return console.error(e);
    }
}

export const addSubcontractorsAction = (data) => async dispatch => {
    try {
        dispatch(addSubcontractors(data));
    } catch (e) {
        return console.error(e);
    }
}

/**
 * Redux action to store labor cost data (taskData, stageData) in project summary slice.
 *
 * @param {Object} data - Labor cost dataset
 * @returns {Function} Redux thunk function
 */
export const addLaborDataAction = (data) => async dispatch => {
    try {
        dispatch(addLaborData(data));
    } catch (e) {
        return console.error(e);
    }
}

/**
 * Redux action to store progress claims array in project summary slice.
 *
 * @param {Array} data - Array of progress claim records
 * @returns {Function} Redux thunk function
 */
export const addProgressClaimsAction = (data) => async dispatch => {
    try {
        dispatch(addProgressClaims(data));
    } catch (e) {
        return console.error(e);
    }
}

/**
 * Redux action to store full options list in project summary slice.
 *
 * @param {Array} data - Array of project options/variations
 * @returns {Function} Redux thunk function
 */
export const addOptionsListAction = (data) => async dispatch => {
    try {
        dispatch(addOptionsList(data));
    } catch (e) {
        return console.error(e);
    }
}

/**
 * Redux action to store resource allocations (timesheet entries) in project summary slice.
 *
 * @param {Array} data - Array of resource allocation / timesheet records
 * @returns {Function} Redux thunk function
 */
export const addResourceAllocationsAction = (data) => async dispatch => {
    try {
        dispatch(addResourceAllocations(data));
    } catch (e) {
        return console.error(e);
    }
}

export const clearProjectAction = () => async dispatch => {
    try {
        dispatch(clearProject());
    } catch (e) {
        return console.error(e);
    }
}